<div class="alert cookie-alert show col-sm-12 pl-lg-5" role="alert" *ngIf="!cookieValue && isLoggedIn">
    <div class="row">
        <div class="col-xl-11 col-sm-10">
            This website stores cookies on your computer. These cookies are used to collect information about how you
            interact with our website and allow us to remember you. We use information to improve and customize your
            browsing experience and for analytics and metrics about our visitors. To find out more, please visit our <a
                href="https://www.thig.com/privacy-statement-security/" target="_blank"><b>Privacy Policy</b></a>
        </div>
        <div class="col-xl-1 col-sm-2">
            <button type="button" class="btn btn-secondary" (click)="accept()">ACCEPT</button>
        </div>
    </div>
</div>
